import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import Loader from "../../Loader";
import NewLogo from "../../NewLogo";
import Constants from "../../../Constants";
import useModule from "../../../hooks/useModule";
import { routeNames } from "../../../routeSegments";
import { getInvestorCompanyDetails } from "../../../Config/config";
import AllInvestorPortfolioIPO from "./AllPortfolioIpos";

const InvPortfolioIpos = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [profile, setProfile] = useState({});
  const [ipoPortfolio, setIpoPortfolio] = useState([]);
  const location = useLocation();
  const { investorId } = useParams();
  const { primaryMasterId } = useModule();

  const getInvestorData = () => {
    setIsLoading(true);
    axios
      .get(`${getInvestorCompanyDetails}${investorId}/`)
      .then((response) => {
        if (response.status === 200) {
          setProfile(response.data?.profile);
          setIpoPortfolio(response.data?.ipo_exits);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getInvestorData();
  }, [investorId]);

  document.title = `${
    profile?.name ? profile.name + " - " : ""
  }PE-VC Investors - Venture Intelligence`;

  return (
    <div>
      {isLoading ? (
        <div className="h-[10rem] w-full bg-[#FFFFFF] flex items-center justify-center">
          <Loader />
        </div>
      ) : (
        <>
          <div className="bg-[#FFFFFF] relative">
            <nav
              className="flex p-1 lg:px-1 px-3 border-b  "
              aria-label="Breadcrumb"
            >
              <ol className="flex items-center space-x-1">
                <li className="flex items-center">
                  <div className="flex items-center">
                    <NavLink
                      to={
                        location.state?.prevPath != null
                          ? location.state?.prevPath
                          : primaryMasterId == Constants.primaryMasterIds.vcId
                          ? routeNames.vc_investors_vc_investments
                          : routeNames.pe_investors_pe_vc_investments
                      }
                      className="ml-2 text-[11pt] lg:text-[12px] text-[#666666] "
                    >
                      Investor
                    </NavLink>
                  </div>
                </li>
                <li>
                  <div className="flex items-center">
                    <span className=" text-[12px] text-[#666666] mr-1">/</span>
                    <span
                      className=" text-[11pt] lg:text-[12px] text-[#666666] font-semibold"
                      aria-current="page"
                    >
                      {profile?.name}
                    </span>
                  </div>
                </li>
                <li>
                  <div className="flex items-center">
                    <span className=" text-[12px] text-[#666666] mr-1">/</span>
                    <span
                      className=" text-[11pt] lg:text-[12px] text-[#666666] font-semibold"
                      aria-current="page"
                    >
                      Portfolio Companies
                    </span>
                  </div>
                </li>
              </ol>
            </nav>
            <div className="bg-[#FFFFFF] profile-detail">
              <div className="pl-5 pr-3">
                <div className="pb-4 pt-6 bg-[#FFFFFF]">
                  <ul>
                    <li className="w-full flex ">
                      <div className=" rounded-md">
                        <NewLogo
                          name={profile.name}
                          id={investorId}
                          menu="investor"
                          page="detail page"
                        />
                      </div>

                      <div className="ml-3 flex flex-1 flex-col">
                        <NavLink
                          className="text-[#333333] text-[22px] font-semibold  leading-[24px]"
                          to={routeNames.investorById(investorId)}
                        >
                          {profile?.name}
                        </NavLink>
                        <span className="text-[12pt] leading-[16pt] text-[#333333]  lg:text-[13px] lg:leading-[17px] font-sans_roman_body  ">
                          {profile?.firm_type ? profile?.firm_type : ""}
                        </span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div>
            <AllInvestorPortfolioIPO
              isLoading={isLoading}
              portfolio={ipoPortfolio}
              investorName={profile.name}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default InvPortfolioIpos;